import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// LocalStorage dan tilni olish, bo'lmasa inglizcha
const getSavedLanguage = () => {
  const saved = localStorage.getItem("i18nextLng");
  return saved || "en";
};

i18n.use(initReactI18next).init({
  lng: getSavedLanguage(), // LocalStorage dan yoki default inglizcha
  fallbackLng: "en",
  resources: {
    en: {
      translation: {
        nav_home: "Home",
        nav_about: "About",
        nav_projects: "Projects",
        nav_experience: "Work",
        nav_education: "Study",
        nav_resume: "CV",
        nav_blog: "Blog",
        type_1: "Frontend Developer",
        type_2: "Full Stack Developer",
        type_3: "UI/UX Designer",
        type_4: "Freelancer",
        contact_me: "Get In Touch",
        introduce_myself: "LET ME INTRODUCE MYSELF",
        find_me_on: "CONNECT WITH ME",
        connect_with_me: "Feel free to reach out",
        social_networks: "SOCIAL MEDIA",
        social_media: "SOCIAL MEDIA",
        quote: "Strive to build things that make a difference!",
        your_name: "Your Full Name",
        your_email: "Your Email Address",
        your_message: "Your Message",
        send_message: "Send Message",
        sending: "Sending...",
        send_success: "Message sent successfully!",
        send_error: "Failed to send message. Please try again.",
        footer_designed: "Designed and Developed by",
        footer_copyright: "Copyright ©",
        read_more: "Read More",
        view_demo: "View Demo",
        view_github: "View Code",
        github: "GitHub",
        no_projects: "No projects yet. Check back soon!",
        no_blogs: "No blog posts yet.",
        recent_works: "My Recent Works",
        recent_works_sub: "Here are a few projects I've worked on recently.",
        github_contributions_title: "Days I",
        code: "Code",
        my_recent: "My Recent",
        works: "Works",
        blogs: "Blogs",
        blog_subtitle: "Here are a few blogs I've written recently.",
        projects_subtitle: "Here are a few projects I've worked on recently.",
        work_experience: "Work Experience",
        work_experience_description:
          "My professional work experience and participation in various projects.",
        education: "Education",
        my_resume: "My Resume / CV",
        my_recent_blogs: "My Recent Blogs",
        blog_description: "Here are a few blogs I've written recently.",
        resume_description:
          "My resume contains detailed information about my professional experience, educational background, technical skills, and certifications. Click the download button above to view it in PDF format.",
        professional: "Professional",
        skillset: "Skillset",
        tools: "Tools",
        i_use: "I use",
        know_who: "Who Am I",
        about_heading: "Know Who I Am",
        // Admin Panel translations
        admin_login: "Admin Login",
        admin_username: "Username",
        admin_password: "Password",
        admin_login_button: "Login",
        admin_logout: "Logout",
        admin_dashboard: "Admin Dashboard",
        admin_profile: "Profile Management",
        admin_skills: "Skills Management",
        admin_education: "Education Management",
        admin_experience: "Experience Management",
        admin_projects: "Projects Management",
        admin_blogs: "Blog Management",
        admin_save: "Save",
        admin_cancel: "Cancel",
        admin_edit: "Edit",
        admin_delete: "Delete",
        admin_add: "Add",
        admin_loading: "Loading...",
        admin_error: "Error",
        admin_success: "Success",
        admin_confirm_delete: "Are you sure you want to delete this item?",
      },
    },
    uz: {
      translation: {
        nav_home: "Asosiy",
        nav_about: "Haqida",
        nav_projects: "Ishlar",
        nav_experience: "Tajriba",
        nav_education: "Ta'lim",
        nav_resume: "CV",
        nav_blog: "Blog",
        type_1: "Frontend dasturchi",
        type_2: "Full Stack dasturchi",
        type_3: "UI/UX dizayner",
        type_4: "Frilanser",
        contact_me: "Bog'lanish",
        introduce_myself: "MEN HAQIMDA",
        find_me_on: "IJTIMOIY TARMOQLAR",
        connect_with_me: "Aloqada bo'ling",
        social_networks: "IJTIMOIY TARMOQLAR",
        social_media: "IJTIMOIY TARMOQLAR",
        quote: "Foydali va sifatli loyihalar yarating!",
        your_name: "Ismingiz",
        your_email: "Email manzilingiz",
        your_message: "Xabaringiz",
        send_message: "Yuborish",
        sending: "Yuborilmoqda...",
        send_success: "Xabar muvaffaqiyatli yuborildi!",
        send_error: "Xabar yuborishda xatolik. Qayta urinib ko'ring.",
        footer_designed: "Dizayn va ishlab chiqish",
        footer_copyright: "Mualliflik huquqi ©",
        read_more: "Batafsil",
        view_demo: "Demo",
        view_github: "Kodni ko'rish",
        github: "GitHub",
        no_projects: "Hozircha loyihalar yo'q.",
        no_blogs: "Hozircha bloglar yo'q.",
        recent_works: "Oxirgi ishlarim",
        recent_works_sub: "Yaqinda amalga oshirgan loyihalarim.",
        github_contributions_title: "Dasturlash",
        code: "kunlarim",
        my_recent: "Mening oxirgi",
        works: "ishlarim",
        blogs: "bloglarim",
        blog_subtitle: "Yaqinda yozgan bloglarim bilan tanishing.",
        projects_subtitle: "Yaqinda yaratgan loyihalarim bilan tanishing.",
        work_experience: "Ish Tajribasi",
        work_experience_description:
          "Mening professional ish tajribam va loyihalarimda ishtirok etganligim.",
        education: "Ta'lim",
        my_resume: "Mening CV / Rezyume",
        my_recent_blogs: "Mening Oxirgi Bloglarim",
        blog_description: "Yaqinda yozgan bloglarim bilan tanishing.",
        resume_description:
          "Rezyumemda mening professional tajribam, ta'lim yo'nalishlarim, texnik ko'nikmalarim va sertifikatlarim haqida batafsil ma'lumot mavjud. Yuklab olish tugmasini bosing va PDF formatda ko'ring.",
        professional: "Professional",
        skillset: "Ko'nikmalarim",
        tools: "Vositalar",
        i_use: "ishlataman",
        know_who: "Men kimman",
        about_heading: "Men haqimda",
        // Admin Panel translations
        admin_login: "Admin Kirish",
        admin_username: "Foydalanuvchi nomi",
        admin_password: "Parol",
        admin_login_button: "Kirish",
        admin_logout: "Chiqish",
        admin_dashboard: "Admin Paneli",
        admin_profile: "Profil Boshqaruvi",
        admin_skills: "Ko'nikmalar Boshqaruvi",
        admin_education: "Ta'lim Boshqaruvi",
        admin_experience: "Tajriba Boshqaruvi",
        admin_projects: "Loyihalar Boshqaruvi",
        admin_blogs: "Blog Boshqaruvi",
        admin_save: "Saqlash",
        admin_cancel: "Bekor qilish",
        admin_edit: "Tahrirlash",
        admin_delete: "O'chirish",
        admin_add: "Qo'shish",
        admin_loading: "Yuklanmoqda...",
        admin_error: "Xatolik",
        admin_success: "Muvaffaqiyat",
        admin_confirm_delete:
          "Haqiqatan ham ushbu elementni o'chirishni xohlaysizmi?",
      },
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
